module.exports = __webpack_public_path__ + "static/img/watches.4e14bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/20210918/watches.jpg
// module id = zzMJ
// module chunks = 1